import { ProduceIcon } from '@/components/produceIcon/produceIcon';
import type { ProduceIconSource } from '@/components/produceIcon/produceArt';
import styles from './photoFallback.module.scss';

export interface PhotoFallbackProps {
  /** The listing's icon — callers get it from useListingIcons(). */
  icon: ProduceIconSource;
  /** Sizing/shape class from the calling surface (thumb, 16:9 media, full-bleed hero). */
  className?: string;
}

/**
 * Stands in for a listing photo when the seller uploaded none.
 *
 * The product's icon on the soft panel gradient — the design team's art where
 * it exists, the emoji otherwise. No white disc behind the art: the gradient
 * alone stands better.
 *
 * Decorative only: the surrounding card always names the product in text, so
 * announcing the icon would just repeat it.
 */
export function PhotoFallback({ icon, className }: PhotoFallbackProps) {
  return (
    <div className={`${styles.fallback} ${className ?? ''}`} aria-hidden>
      <ProduceIcon icon={icon} className={icon.art ? styles.art : styles.emoji} />
    </div>
  );
}
